<template>
  <v-container fluid>
    <v-row justify="space-around">
      <v-col cols="11">
        <v-card>
          <v-container fill-height fluid class="grey lighten-3">
            <v-row fill-height>
              <v-col v-if="typeof getProject.title !== 'undefined'" cols="12">
                <span class=" hyphens headline">{{ getProject.title }}</span>
              </v-col>
              <v-col
                v-if="
                  typeof getProject.owner !== 'undefined' &&
                    typeof getProject.owner.full_name !== 'undefined'
                "
                cols="12"
              >
                <span class=" hyphens font-weight-regular"
                  >Creado por
                  {{ getProject.owner ? getProject.owner.full_name : "" }}</span
                >
              </v-col>
            </v-row>
          </v-container>
          <v-card-title>
            <v-col cols="12">
              <v-tabs
                v-model="active"
                color="white"
                dark
                slider-color="cyan"
                grow
              >
                <v-tab v-for="tab in tabs" :key="tab">
                  {{ tab }}
                </v-tab>
                <v-tab-item v-for="tab in tabs" :key="tab">
                  <v-row v-if="tab === 'Resumen'">
                    <v-col cols="4">
                      <v-card height="380px">
                        <v-list rounded dense>
                          <v-list-item-group color="blue darken-4">
                            <v-list-item
                              v-for="item in side_options"
                              :key="item"
                            >
                              <v-list-item-content>
                                <v-list-item-title
                                  class="title"
                                  style="cursor:pointer; height: 35px;"
                                  @click="updateName(item)"
                                  >{{ item }}</v-list-item-title
                                >
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-card>
                    </v-col>

                    <v-col cols="8">
                      <v-card height="100%">
                        <v-card-title>
                          <div v-if="option_overview === 'Descripción'">
                            <div
                              class="font-weight-bold "
                              style="font-size: 15px"
                            >
                              En esta sección encontrará la descripción del
                              presente proyecto.
                            </div>
                            <v-divider> </v-divider>
                            
                            <span class="body-1 text-justify hyphens mt-4">{{
                              getProject.description
                            }}</span>
                          </div>

                          <v-card
                            flat
                            width="900px"
                            v-else-if="option_overview === 'Linea de tiempo'"
                          >
                            <div
                              class="font-weight-bold "
                              style="font-size: 15px"
                            >
                              En esta sección se detalla la información en el
                              tiempo del presente proyecto.
                            </div>
                            <v-divider> </v-divider>
                            <div class="text-right mt-4">
                              <v-dialog v-model="dialogMilestone" width="500">
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    class="white--text"
                                    color="primary"
                                    v-if="user_logged_owner"
                                    v-on="on"
                                  >
                                    Añadir Milestone
                                  </v-btn>
                                </template>

                                <v-card>
                                  <v-card-title
                                    class="headMilestonesline grey lighten-2"
                                    primary-title
                                  >
                                    Nuevo Milestone
                                  </v-card-title>

                                  <v-card-text>
                                    <!-- Add datepicker and description -->
                                    <v-row>
                                      <v-col cols="4">
                                        <v-menu
                                          ref="menu"
                                          dark
                                          color="black"
                                          v-model="menu_end"
                                          :close-on-content-click="false"
                                          :nudge-right="40"
                                          :return-value.sync="date_end"
                                          transition="scale-transition"
                                          offset-y
                                          full-width
                                          min-width="290px"
                                        >
                                          <template v-slot:activator="{ on , attrs}">
                                            <v-text-field
                                              v-model="date_end"
                                              label="Fecha final"
                                              prepend-icon="mdi-calendar"
                                              v-bind="attrs"
                                              v-on="on"
                                            ></v-text-field>
                                          </template>
                                          <v-date-picker
                                            v-model="date_end"
                                            no-title
                                            scrollable
                                          >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                              text
                                              color="primary"
                                              @click="menu_end = false"
                                              >Cancel</v-btn
                                            >
                                            <v-btn
                                              text
                                              color="primary"
                                              @click="save(date_end)"
                                              >OK</v-btn
                                            >
                                          </v-date-picker>
                                        </v-menu>
                                      </v-col>

                                      <v-col cols="1"></v-col>

                                      <v-col cols="7">
                                        <v-textarea
                                          v-model="newDescription"
                                          name="input-7-1"
                                          label="Descripcion del milestone"
                                          clearable
                                        />
                                      </v-col>
                                    </v-row>
                                  </v-card-text>

                                  <v-divider></v-divider>

                                  <v-card-actions>
                                    <v-btn
                                      color="primary"
                                      text
                                      @click="upload_milestone"
                                    >
                                      Guardar
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      color="primary"
                                      text
                                      @click="dialogMilestone = false"
                                    >
                                      Cancelar
                                    </v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </div>
                            <v-timeline dense align-top>
                              <v-timeline-item
                                v-for="mile in new_milestones"
                                :key="mile.description"
                                :date="mile.date"
                                :desc="mile.description"
                              >
                                <v-card class="elevation-3">
                                  <v-row justify="space-between">
                                    <v-col cols="auto">
                                      <v-card-title class="font-size-small">{{
                                        mile.date.toDate().toLocaleDateString()
                                      }}</v-card-title>
                                      <v-card-text
                                        v-model="descriptionMilestone"
                                      >
                                        {{ mile.description }}
                                      </v-card-text>
                                    </v-col>
                                    <v-col cols="auto">
                                      <v-card-actions v-if="user_logged_owner">
                                        <v-btn icon>
                                          <v-icon
                                            color="black"
                                            @click="deleteMilestones(mile)"
                                            >mdi-close</v-icon
                                          >
                                        </v-btn>
                                      </v-card-actions>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-timeline-item>
                            </v-timeline>
                          </v-card>

                          <v-card
                            flat
                            width="900px"
                            v-else-if="option_overview === 'Contribuidores'"
                          >
                            <div
                              class="font-weight-bold "
                              style="font-size: 15px"
                            >
                              En esta sección encontrará los usuarios
                              contribuidores.
                            </div>
                            <v-divider> </v-divider>
                            <ContributorSection />
                          </v-card>

                          <v-card
                            flat
                            width="900px"
                            v-else-if="
                              option_overview === 'Documentos' && owner
                            "
                          >
                            <div
                              class="font-weight-bold "
                              style="font-size: 15px"
                            >
                              En esta sección encontrarán los documentos
                              asociados al presente proyecto.
                            </div>
                            <v-divider> </v-divider>
                            <Documents />
                          </v-card>
                        </v-card-title>
                      </v-card>
                    </v-col>
                  </v-row>

                  <!-- Discussion part -->
                  <v-row v-else align="center" justify="center">
                    <v-container wrap>
                      <v-layout>
                        <v-col cols="6">
                          <v-row justify="space-around" align="center">
                            <v-flex xs4>
                              <v-combobox
                                label="Filtrar por"
                                :items="filter_items"
                                v-model="filter_by"
                                @change="orderList(topics)"
                              />
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                label="Buscar"
                                v-model="search_value"
                                @change="filterList()"
                              ></v-text-field>
                            </v-flex>
                          </v-row>
                          <v-row aling="center" justify="space-around">
                            <v-btn text small color="black" @click="cleanFilter"
                              >Limpiar Filtro</v-btn
                            >
                          </v-row>
                        </v-col>
                        <v-col cols="4">
                          <v-row align="center">
                            <v-flex xs4>
                              <v-combobox
                                v-model="order_by"
                                label="Ordenar por"
                                :items="order_items"
                                @change="orderList(topics)"
                              />
                          </v-flex>
                          </v-row>
                        </v-col>
                        <v-col cols="2">
                          <v-row align="center" justify="center">
                            <v-btn
                              color="primary white--text"
                              @click="changePage()"
                              style="cursor:pointer;"
                            >
                              Nuevo Tópico
                            </v-btn>
                          </v-row>
                        </v-col>
                      </v-layout>
                    </v-container>
                    <v-container>
                      <v-row align="center" justify="end">
                        
                      </v-row>
                    </v-container>
                    <v-col cols="12">
                      <v-card
                        class="black--text"
                        v-for="topic in arrayOrder.slice(
                          first_index,
                          second_index
                        )"
                        :key="topic.id"
                      >
                        <v-row justify="space-around" align="center">
                          <v-col cols="5">
                            <v-col>
                              <div
                                v-on:click="go_to_thread(topic.id)"
                                style="cursor:pointer;"
                                class="title text-justify hyphens"
                              >
                                {{ topic.title }}
                              </div>
                              <div class="body-1">
                                Author: {{ topic.owner.full_name }}
                              </div>
                              <div v-if="topic.description.length < 200" class="body-1 text-justify hyphens black--text">
                                <span v-html="topic.description"></span>
                              </div>
                              <div v-else class="body-1 text-justify hyphens black--text">
                                <span v-html="topic.description.slice(0,200)">...</span>
                              </div>
                            </v-col>
                          </v-col>
                          <v-col cols="5">
                            <v-row align="center">
                              <v-col>
                                <div class="text-center body-1" v-if="topic.state == true">
                                  Tópico abierto
                                </div>
                                <div class="text-center body-1" v-else>
                                  Tópico cerrado
                                </div>
                                <div
                                  v-if="
                                    typeof topic.last_comment !== 'undefined'
                                  "
                                >
                                  <div
                                    v-if="
                                      typeof topic.last_comment.full_name !=
                                        'undefined' && topic.total_comments > 0
                                    "
                                    class="text-center body-1"
                                  >
                                    Ultimo comentario por
                                    {{ topic.last_comment.full_name }}
                                  </div>
                                  <div class="text-center body-1">
                                    {{ topic.last_comment.creation_dt }}
                                  </div>
                                  <div class="text-center body-1">
                                    Comentarios de acuerdo:
                                    {{ topic.agree_comments }}
                                  </div>
                                  <div class="text-center body-1">
                                    Comentarios en desacuerdo:
                                    {{
                                      topic.total_comments -
                                        topic.agree_comments
                                    }}
                                  </div>
                                  <div>
                                    <a class="black--text body-2" />
                                  </div>
                                </div>
                                <div class="text-center body-1" v-else>
                                  No hay actualizaciones.
                                </div>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="1">
                            <v-card-title class="pa-0 ma-0" primary-title>
                              <v-row
                                class="pa-0 ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-col cols="12">
                                  <v-icon>mdi-comment</v-icon>
                                </v-col>
                                <v-col cols="12">
                                  <div justify="center">
                                    {{ topic.total_comments }}
                                  </div>
                                </v-col>
                              </v-row>
                            </v-card-title>
                          </v-col>
                          <v-col
                            col="1"
                            v-if="topic.owner.email == currentUser.email"
                          >
                            <v-row justify="center" align="center">
                              <v-btn icon>
                                <v-icon
                                  class="pa-0 ma-0"
                                  color="black"
                                  @click="edit_topic(topic.id)"
                                  >mdi-pencil</v-icon
                                >
                              </v-btn>
                            </v-row>
                            <v-row justify="center" align="center">
                              <v-btn icon>
                                <v-icon
                                  class="pa-0 ma-0"
                                  color="black"
                                  @click="delete_topic(topic.id)"
                                  >mdi-close</v-icon
                                >
                              </v-btn>
                            </v-row>
                          </v-col>
                          <v-col col="1" v-else> </v-col>
                        </v-row>
                      </v-card>
                      <v-layout wrap>
                        <v-flex xs8>
                          <v-pagination
                            v-model="page"
                            class="my-4"
                            :length="length_page"
                            total-visible="7"
                            @next="getCorrectList(page)"
                            @previous="getCorrectList(page)"
                          />
                        </v-flex>
                        <v-flex xs2>
                          <v-combobox
                            v-model="len_list"
                            label="Tópicos por página"
                            :items="items"
                            @change="changeLenList(arrayOrder)"
                          />
                        </v-flex>
                      </v-layout>
                    </v-col>
                  </v-row>
                </v-tab-item>
              </v-tabs>
            </v-col>
          </v-card-title>
          <v-card-actions>
            <v-btn color="primary  white--text" @click="return_project"
              >Regresar a Proyectos</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <!--SnackBar for errors-->
    <v-snackbar v-model="snackbar" :right="true" :timeout="3000" :top="true">
      {{ message_snack }}
      <v-btn color="pink" text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbarDelete"
      :right="true"
      :timeout="3000"
      :top="true"
    >
      {{ message_delete }}
      <v-btn color="pink" text @click="snackbar = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import firebase, { firestore, auth } from "firebase";
import moment from "moment";
import Documents from "../../components/documents/Documents.vue";
import ContributorSection from "../../components/contributors/ContributorSection.vue";

export default {
  components: {
    Documents,
    ContributorSection
  },

  data() {
    return {
      arrayOrder: [],
      order_by: "Título A-Z",
      order_items: [
        "Título A-Z",
        "Título Z-A",
        "Propietario A-Z",
        "Propietario Z-A"
      ], // "Fecha de creación ASC", "Fecha de creacion DES"],
      filter_items: ["Autor", "Título", "Número de comentarios", "Sin Filtro"],
      filter_by: "",
      search_value: "",
      first_index: 0,
      second_index: 0,
      len_list: 5,
      items: [5, 10, 20],
      length_page: 0,
      page: 1,
      descriptionMilestone: "",
      user_data: "",
      userid: "",
      project: [],
      refProject: 0,
      image: "https://cdn.vuetifyjs.com/images/cards/house.jpg",
      description: "",
      snackbar: false,
      message_snack: "",
      snackbarDelete: false,
      message_delete: "",
      owner: false,
      currentUser: "",
      user_contributor: false,
      user_logged_name: "",
      user_logged_owner: false,  //Author del proyecto
      title_project: "",
      newDescription: "",
      date_end: new Date().toISOString().substr(0, 10),
      menu_end: false,
      files: "",
      dialog: false,
      dialogMilestone: false,
      tabs: ["Resumen", "Discusiones"],
      side_options: [
        "Descripción",
        "Linea de tiempo",
        "Documentos",
        "Contribuidores"
      ],
      active: null,
      drawer: true,
      option_overview: "Descripción",
      documents: [],
      milestones: [],
      new_milestones:[],
      type: "last comment by",
      cont: "Jhonny Torres hace 2 horas",
      imageDist: "https://cdn.vuetifyjs.com/images/cards/sunshine.jpg",
      tab_discussion: null,
      items_discussion: ["Todos", "Mis Comentarios", "Actualizaciones"],
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    };
  },

  computed: {
    ...mapState("discussion", ["topics"]),
    ...mapState("milestones", ["listMilestone"]),
    ...mapGetters("projects", ["getProject"]),
    computedDateFormattedMomentjs() {
      return this.date_end ? moment(this.date_end).toISOString() : "";
    }
  },
  created() {
    this.onceProject();
    this.listTopics();

  },
  mounted() {
    this.filter_by = "Título";
    this.new_milestones = [...this.listMilestone];

    // eslint-disable-next-line no-undef
    if (auth().currentUser !== null) {
      this.owner = true;
      this.currentUser = firebase.auth().currentUser;
      // eslint-disable-next-line no-console
      console.log(this.getProject)
      //console.log("proyecto cargado correctamente");

      // get full_name of user
      firestore()
        .collection("User")
        .doc(this.currentUser.uid)
        .onSnapshot(result => {
          const data = result.data();
          let first_name = data.first_name ? data.first_name : "";
          let last_name = data.last_name ? data.last_name : "";
          let full_name_user = first_name + " " + last_name;
          this.user_logged_name = full_name_user.trim();
          if (this.user_logged_name == this.getProject.owner.full_name) 
            this.user_logged_owner = true;
        });
    }
  },
  watch: {
    topics: function() {
      if (this.topics.length) {
        this.orderList(this.topics);
        this.second_index = this.page * this.len_list;
        this.length_page = Math.ceil(this.topics.length / this.len_list);
      }
    },
    page: function(page) {
      this.getCorrectList(page);
    }
  },
  methods: {
    ...mapActions("discussion", ["listTopics"]),
    ...mapActions("discussion", ["removeTopics"]),
    ...mapActions("projects", ["onceProject"]),
    ...mapActions("milestones", ["loadMilestone", "saveMilestone"]),
    ...mapMutations("milestones", ["INSERT_MILESTONE", "DELETE_MILESTONE"]),
    // eslint-disable-next-line no-unused-vars
    lastComment(topicID) {
      // eslint-disable-next-line no-console
      const array = this.getComment;
      // eslint-disable-next-line no-unused-vars
      const tamano = array.length - 1;
      return array;
    },
    save(date){
      this.$refs.menu[0].save(date);
    },
    formatDate(date) {
      return date.split("T")[0];
    },

    return_project() {
      this.$router.push({
        name: `projects`
      });
    },
    // Methods to milestones
    upload_milestone() {
      const user = auth().currentUser;
      if (user !== null) {
        const dateString = firestore.Timestamp.fromDate(
          new Date(this.date_end)
        );
        const milestone = {
          date: dateString,
          description: this.newDescription
        };
        // eslint-disable-next-line no-console
        console.log(milestone);
        this.INSERT_MILESTONE(milestone);
        this.saveMilestone();
      }
      this.dialogMilestone = false;
      this.newDescription="";
    },
    deleteMilestones(milestone){
      var r = confirm("¿Estás seguro que quieres eliminar el milestone?");
      if (r == true) {
        this.new_milestones = this.new_milestones.filter(
          item => item.description !== milestone.description
        );
        const projectID = this.$route.params.project_id;

        firestore()
          .collection("Project")
          .doc(projectID)
          .set(
            {
              milestones: this.new_milestones
            },
            { merge: true }
          )
          .then(() => {
            this.message_delete = "Su milestone se ha eliminado correctamente";
            this.snackbarDelete = true;
            this.new_milestones;
            // eslint-disable-next-line no-console
            console.log("Los milestones fueron actualizados");
          })
          .catch(() => {
            // eslint-disable-next-line no-console
            console.log("No se guardo los nuevos milestones");
          });
      } else {
        // eslint-disable-next-line no-console
        console.log("No se eliminó el milestone");
      }
    },

    // Methods to contributors
    delete_contributor(contributor) {
      this.contributors.splice(this.contributors.indexOf(contributor), 1);
    },

    // Methods to recomenders
    validate_recommender(recomendado) {
      // eslint-disable-next-line no-console
      console.log(recomendado);
      if (this.contributors.length < 1) {
        this.add_recommender(recomendado);
        this.message_snack = "Recomendado agregado como contribuidor";
        this.snackbar = true;
      } else {
        this.contributors.forEach(item => {
          // eslint-disable-next-line no-console
          console.log(item.name + " " + recomendado.name);
          // eslint-disable-next-line no-console
          console.log(
            JSON.stringify(item) === JSON.stringify(recomendado) + "\n"
          );
          if (JSON.stringify(item) === JSON.stringify(recomendado)) {
            this.delete_recommender(item);
            this.message_snack = "Recomendado ya existe como contribuidor";
            this.snackbar = true;
            return;
          }
        });
        this.add_recommender(recomendado);
        this.message_snack = "Recomendado agregado como contribuidor";
        this.snackbar = true;
      }
    },
    delete_topic(topicID) {
      var r = confirm("¿Estás seguro que quieres eliminar el tópico?");
      if (r == true) {
        const projectID = this.$route.params.project_id;
        firestore()
          .collection("Project")
          .doc(projectID)
          .collection("Topic")
          .doc(topicID)
          .delete()
          .then(() => {
            this.message_delete = "Su tópico se ha eliminado correctamente";
            this.snackbarDelete = true;
            this.listTopics();
          });
      } else {
        // eslint-disable-next-line no-console
        console.log("No se eliminó el tópico");
      }
    },
    return_topic(project_id, validationOwner) {
      this.$router.push({
        path: `/dashboard/${project_id}/${validationOwner}`
      });
    },
    add_recommender(recomendado) {
      this.contributors.push(recomendado);
      this.delete_recommender(recomendado);
    },

    delete_recommender(recomendado) {
      const x = this.recomendados.indexOf(recomendado);
      x != -1
        ? this.recomendados.splice(this.recomendados.indexOf(recomendado), 1)
        : // eslint-disable-next-line no-console
          console.log("Error");
    },

    // Others methods
    updateName(value) {
      this.option_overview = value;
    },
    edit_topic(topicID) {
      this.$router.push({
        path: `/edittopic/${this.$route.params.project_id}/${topicID}`
      });
    },
    changePage() {
      const user = auth().currentUser;
      if (user !== null) {
        this.$router.push({
          path: `/newtopic/${this.$route.params.project_id}/${this.$route.params.owner}`
        });
      } else {
        this.message_snack = "Inicie sesión para un nuevo topico";
        this.snackbar = true;
      }
    },

    go_to_thread(topic_id) {
      this.$router.push({
        path: `/threadtopic/${topic_id}/${this.$route.params.project_id}`
      });
    },

    // Methods to filter, pagination and order
    getCorrectList(page) {
      this.second_index = page * this.len_list;
      this.first_index = this.second_index - this.len_list;
    },
    changeLenList(listTopics) {
      this.page = 1;
      this.length_page = Math.ceil(listTopics.length / this.len_list);
      this.getCorrectList(this.page);
    },
    orderList(topics) {
      const arrayCopy = [];

      topics.forEach(topic => {
        if (!topic.total_comments) {
          topic.total_comments = 0;
        }
        arrayCopy.push(topic);
      });

      if (this.order_by === "Título A-Z") {
        arrayCopy.sort((a, b) =>
          a.title > b.title ? 1 : b.title > a.title ? -1 : 0
        );
      } else if (this.order_by === "Título Z-A") {
        arrayCopy.sort((a, b) =>
          a.title < b.title ? 1 : b.title < a.title ? -1 : 0
        );
      } else if (this.order_by === "Propietario A-Z") {
        arrayCopy.sort((a, b) =>
          a.owner.full_name > b.owner.full_name
            ? 1
            : b.owner.full_name > a.owner.full_name
            ? -1
            : 0
        );
      } else if (this.order_by === "Propietario Z-A") {
        arrayCopy.sort((a, b) =>
          a.owner.full_name < b.owner.full_name
            ? 1
            : b.owner.full_name < a.owner.full_name
            ? -1
            : 0
        );
      }
      this.arrayOrder = arrayCopy;
      this.getCorrectList(this.page);
    },
    filterList() {
      let filter_array = [];

      this.arrayOrder.filter(project => {
        if (this.filter_by == "Autor") {
          let pos = project.owner.full_name
            .toLowerCase()
            .indexOf(this.search_value.toLowerCase());
          if (pos >= 0) filter_array.push(project);
        } else if (this.filter_by == "Título") {
          let pos = project.title
            .toLowerCase()
            .indexOf(this.search_value.toLowerCase());
          if (pos >= 0) filter_array.push(project);
        } else if (this.filter_by == "Número de comentarios") {
          // eslint-disable-next-line no-console
          //  console.log(project);
          if (project.total_comments >= this.search_value)
            filter_array.push(project);
        } else if (this.filter_by == "Sin Filtro") {
          this.cleanFilter();
        }
      });
      this.arrayOrder = filter_array;
      this.changeLenList(this.arrayOrder);
      // eslint-disable-next-line no-console
      console.log(this.arrayOrder.length);
    },
    cleanFilter() {
      this.filter_by = "Sin Filtro";
      this.search_value = "";
      this.orderList(this.topics);
      this.changeLenList(this.topics);
    }
  }
};
</script>
<style>
.hyphens {
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
